export default "__VITE_ASSET__e89e56e3__"